import { FC, useState } from "react";
import { CreateClusterButton } from "@/components/HomePage/CreateClusterButton/CreateClusterButton";
import { CreditsField } from "@/components/Common/CreditsField/CreditsField";
import { PurchaseCreditsModal } from "@/components/Common/PurchaseCreditsModal/PurchaseCreditsModal";
import { RequestCreditsModal } from "@/components/Common/RequestCreditsModal/RequestCreditsModal";
import { SupportModal } from "@/components/Common/SupportModal/SupportModal";
import { ThemeToggle } from "@/components/Common/ThemeToggle/ThemeToggle";
import { UserButton } from "@/components/Common/UserButton/UserButton";
import { UserBalance } from "@/components/Common/UserBalance/UserBalance";
import { UserNotificationsButton } from "@/components/Common/UserNotificationsButton/UserNotificationsButton";
import { Button } from "@/components/ui/button";
import env from "@/env";
import { useExplorerOnlyMode } from "@/hooks/useExplorerOnlyMode";
import { useMainStore } from "@/store/main";
import { useAuthState } from "@/store/auth";
import { BalanceType } from "@/types/user";
import { getIsCreditsEnabled } from "@/utils/credits";
import { explorerPrefixedPath } from "@/utils";
import { stringify } from "qs";
import { useLocation } from "wouter";
import { HeaderDocsButton } from "./HeaderDocsButton";
import { HeaderMyPlanButton } from "./HeaderMyPlanButton";

export const AppHeaderActions: FC = () => {
  const [location, setLocation] = useLocation();
  const tool = useMainStore((state) => state.tool);
  const { value } = tool || {};
  const isLoggedIn = useAuthState((state) => state.status === "authenticated");
  const [isPurchaseCreditsModalOpen, setIsPurchaseCreditsModalOpen] = useState(false);
  const [isRequestCreditsModalOpen, setIsRequestCreditsModalOpen] = useState(false);
  const [isSupportModalOpen, setIsSupportModalOpen] = useState(false);
  const explorerOnlyMode = useExplorerOnlyMode();

  // const handleUsageAndBilling = () => {
  //   if (window.location.pathname.includes("/ai")) {
  //     setLocation(explorerPrefixedPath("/id/account/intelligence"));
  //     setTimeout(() => {
  //       window.location.hash = "daily-credits-usage";
  //     }, 100);
  //   } else {
  //     setLocation(explorerPrefixedPath("/id/funds"));
  //   }
  // };

  return (
    <>
      <SupportModal
        isOpen={isSupportModalOpen}
        onClose={() => setIsSupportModalOpen(false)}
      />
      <RequestCreditsModal
        isOpen={isRequestCreditsModalOpen}
        onClose={() => {
          setIsRequestCreditsModalOpen(false);
        }}
      />
      <PurchaseCreditsModal
        isOpen={isPurchaseCreditsModalOpen}
        onClose={() => {
          setIsPurchaseCreditsModalOpen(false);
        }}
      />

      {!getIsCreditsEnabled() && (value === "cloud" || value === "worker") && isLoggedIn && (
        <div className="hidden items-center gap-3 lg:flex">
          {value === "cloud" && (
            <>
              <UserBalance type={BalanceType.IOCLOUD} />
              <div className="h-[12px] w-[1px] bg-gray-dark-1200"></div>
              <UserBalance type={BalanceType.CLOUD} />
            </>
          )}
          {value === "worker" && <UserBalance type={BalanceType.IOWORKER} />}
        </div>
      )}
      {getIsCreditsEnabled() && value !== "ai" && (
        <CreditsField
          className="max-lg:hidden"
          onPurchaseCredits={() => {
            if (env.FEATUREFLAG_PURCHASE_CREDITS_ENABLED) {
              setIsPurchaseCreditsModalOpen(true);
              return;
            }

            setIsRequestCreditsModalOpen(true);
          }}
        />
      )}

      {/* {isLoggedIn && (
        <Button
          className="max-md:hidden"
          size="xs"
          variant="outline"
          onClick={handleUsageAndBilling}
        >
          Usage & Billing
        </Button>
      )} */}
      {value === "cloud" && (
        <div className="hidden lg:block">
          {env.FEATUREFLAG_CLUSTER_DEPLOYMENT_ENABLED && <CreateClusterButton />}
        </div>
      )}
      {!isLoggedIn && <HeaderDocsButton />}
      <ThemeToggle />

      {isLoggedIn && (
        <>
          {value === "ai" && <HeaderMyPlanButton />}
          {/* In EXPLORER_ONLY_MODE, notifications move into the mobile menu burger */}
          <span className={explorerOnlyMode ? "max-lg:hidden" : ""}>
            <UserNotificationsButton />
          </span>
          <HeaderDocsButton />
          {explorerOnlyMode && (
            <span className="max-lg:hidden">
              <UserButton onOpenSupport={() => setIsSupportModalOpen(true)} />
            </span>
          )}
        </>
      )}

      {!isLoggedIn && (
        <>
          <span className="hidden h-[16px] w-[1px] bg-separator lg:flex"></span>
          <Button
            className="max-md:hidden"
            size="xs"
            variant="standout"
            onClick={() => {
              setLocation(
                `${explorerPrefixedPath("/login/signup")}?${stringify({
                  r: location
                })}`
              );
            }}
          >
            Sign Up
          </Button>
          <Button
            className="max-md:hidden"
            size="xs"
            variant="outline"
            onClick={() => {
              setLocation(
                `${explorerPrefixedPath("/login")}?${stringify({
                  r: location
                })}`
              );
            }}
          >
            Login
          </Button>
        </>
      )}
    </>
  );
};
